import {UPDATE_CUSTOM_FORM_DATA} from '../mutationTypes';

export default {
  [UPDATE_CUSTOM_FORM_DATA](state, {data, alias}) {
    if (data && data.data && alias) {
      state.customForm = {...state.customForm, [alias]: data.data};
    }
  },
};
